<template>
  <span>
    <span class="screenplay-shadow"></span>
    <span :class="customClass" class="screenplay-holder">
      <span class="screenplay-holder-info">
        <span class="screenplay-holder__header">
          <span class="screenplay-holder__title"></span>
          <a @click="closeFirstTutorial" class="screenplay-holder__close"></a>
        </span>
        <!-- screenplay-holder__header -->
        <span
          class="screenplay-holder__content text-center"
          v-html="project.UF_HELP.SCENARIO.STEP1[stepName]"
        ></span>

        <!-- screenplay-holder__content -->
      </span>
      <!-- screenplay-holder-info -->
      <span class="screenplay-holder__footer">
        <span class="screenplay-holder__etap">
          шаг {{ project.ARR1.indexOf(stepName) + 1 }} из
          {{ project.ARR1.length }}
        </span>
        <span class="screenplay-holder__butt-area">
          <a
            v-if="project.ARR1.indexOf(stepName) > 0"
            @click="nextStepFirstTutorial($event, stepName, 'decrement')"
            class="screenplay-holder__butt screenplay-holder__butt-prev"
          >
            Шаг назад
          </a>
          <span v-else></span>
          <a
            @click="nextStepFirstTutorial($event, stepName, 'increment')"
            class="screenplay-holder__butt screenplay-holder__butt-next"
          >
            {{
              project.ARR1.indexOf(stepName) + 1 !== project.ARR1.length
                ? "Далее"
                : "Завершить"
            }}
          </a>
        </span>
      </span>
    </span>
  </span>
</template>

<script>
export default {
  name: "FirstScenariosStep",
  props: ["project", "stepName", "customClass"],

  methods: {
    nextStepFirstTutorial(event, step, operation) {
      event.stopImmediatePropagation();
      const operations = {
        decrement: "-1",
        increment: 1
      };
      this.project[step] = false;
      const nextIndexStep =
        this.project.ARR1.indexOf(step) + Number(operations[operation]);
      if (nextIndexStep < this.project.ARR1.length) {
        this.project[this.project.ARR1[nextIndexStep]] = true;
        const el = this.$parent.$refs[this.project.ARR1[nextIndexStep]];
        if (el) {
          if (Array.isArray(el)) {
            el[0].scrollIntoView({
              behavior: "smooth",
              block: "center"
            });
          } else {
            el.scrollIntoView({
              behavior: "smooth",
              block: "center"
            });
          }
        }
      } else {
        this.closeFirstTutorial();
      }
    },
    closeFirstTutorial() {
      event.stopImmediatePropagation();
      const el = document.getElementsByClassName("area-shadow")[0];
      el.classList.remove("active");
      const footer = document.getElementsByClassName("footer")[0];
      footer.classList.remove("active");
      this.project.ARR1.forEach(el => {
        if (el in this.project) {
          this.project[el] = false;
        }
      });
    }
  }
};
</script>

<style scoped></style>
